// extracted by mini-css-extract-plugin
export default {"container":"CustomerProfile_container__13Vu5","loginText":"CustomerProfile_loginText__+kYaq","loginLink":"CustomerProfile_loginLink__PgXuT"};